import { Component, OnInit } from '@angular/core';
import { ProService } from 'src/app/db/models/pro-services';
import { ProfessionalServiceService } from 'src/app/services/professional-service.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  allservices: ProService[];
  serviceTotal = 0;

  constructor(
    private pservice: ProfessionalServiceService
  ) { }

  ngOnInit() {
    this.getAllServices();
  }

  getAllServices(){
    this.pservice.getAllProfessionalServices().subscribe(
      res => {
        this.allservices = res;
        this.serviceTotal = this.allservices.length;
      }
    )
  }

}
